import { render, staticRenderFns } from "./OurBuisiness.vue?vue&type=template&id=ccd2e9da&scoped=true"
import script from "./OurBuisiness.vue?vue&type=script&lang=js"
export * from "./OurBuisiness.vue?vue&type=script&lang=js"
import style0 from "./OurBuisiness.vue?vue&type=style&index=0&id=ccd2e9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd2e9da",
  null
  
)

export default component.exports